module["exports"] = [
  "Adventure Road Bicycle",
  "BMX Bicycle",
  "City Bicycle",
  "Cruiser Bicycle",
  "Cyclocross Bicycle",
  "Dual-Sport Bicycle",
  "Fitness Bicycle",
  "Flat-Foot Comfort Bicycle",
  "Folding Bicycle",
  "Hybrid Bicycle",
  "Mountain Bicycle",
  "Recumbent Bicycle",
  "Road Bicycle",
  "Tandem Bicycle",
  "Touring Bicycle",
  "Track/Fixed-Gear Bicycle",
  "Triathlon/Time Trial Bicycle",
  "Tricycle"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/vehicle/bicycle.js
// module id = 2662
// module chunks = 1610